<div class="photo">
  <lib-image-loader
    [maxScale]="1.5"
    [fullscreenZoom]="false"
    [hasZoom]="true"
            [originalUrl]="
            {
            photoId: photoId,
            hash
            : ($safeNavigationMigration((photoId | photoData | async)?.photoGroupId) | getGroupWatermarkHash
            : 'anyone'),
            photoGroupId: $safeNavigationMigration((photoId | photoData | async)?.photoGroupId)
            }
            | watchPhotoGroupWatermarkUpdates
            | async
            | getImageUrl
            : $safeNavigationMigration((photoId | photoData | async)?.photoGroupId)
            : 'anyone'
            : context: $safeNavigationMigration((photoId | photoData | async)?.photoGroupId)
            : 2000
            : ($safeNavigationMigration((photoId | photoData | async)?.photoGroupId) | getGroupWatermarkHash: 'anyone')
            "
            [url]="
            photoId
            | photoData
            | async
            | getImageUrl
            : $safeNavigationMigration((photoId | photoData | async)?.photoGroupId):'anyone'
            : context
            : (shoppingCartContext$ | async).contextId
            : 600
            | async"
></lib-image-loader>
</div>
@if (isPhonePortrait$ | async) {
  <div class="button">
    <lib-button (click)="dialog.closeLastFull()" forceContext="productFront" translate>comeBack</lib-button>
  </div>
}
